import type { Tokens } from '../../../../theming/types'
import { styles } from '../../../../utilities'

const badgeStyles = (size: string) => ({
  badge: {
    height: size,
    width: size,
  },
})

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      badge: {
        backgroundColor: tokens.messageBgColorAlert,
        border: `2px solid ${tokens.borderColorEmphasisInverse}`,
        boxSizing: 'content-box',
        borderRadius: '50%',
        display: 'inline-flex',
      },
    },

    sizeXxlarge: badgeStyles('12px'), // Olive only; use large styles in Ink
    sizeXlarge: badgeStyles('12px'), // Olive only; use large styles in Ink
    sizeLarge: badgeStyles('12px'),
    sizeMedium: badgeStyles('10px'),
    sizeSmall: badgeStyles('8px'),
    sizeXsmall: badgeStyles('6px'),

    hidden: styles.visuallyHidden,
  } as const
}
